export class KeelError extends Error {
    code;
    details;
    constructor(code, message, details) {
        super(message);
        this.code = code;
        this.details = details;
        this.name = 'KeelError';
    }
}
export const assertNever = (x, what = 'value') => { throw new KeelError('INTERNAL', `Unexpected ${what}: ${String(x)}`); };
export function invariant(cond, message, code = 'VALIDATION', details) {
    if (!cond)
        throw new KeelError(code, message, details);
}
//# sourceMappingURL=errors.js.map